import { track } from '@zillow/universal-analytics';
import { initMstSentryScope } from '@zillow/mst-sentry';
import pjson from '../../package.json';
import { SENTRY_PROJECT_NAME, SENTRY_ADS_DSN } from './constants';

const environment = process.env.NODE_ENV || 'local';
const version = `ads-mfe-${pjson.version}v`;

export const sentryScope = initMstSentryScope(
    SENTRY_PROJECT_NAME,
    SENTRY_ADS_DSN,
    environment,
    version,
    'mfe'
);

export const captureException = error => {
    sentryScope?.captureException(error);
};

export const safeTrack = (...args) => {
    try {
        track(...args);
    } catch (e) {
        captureException(e);
    }
};
